export const LOGGED_IN_USER_DATA = "okta-token-storage";
export const LOGGED_IN_USER_DATA_COOKIE = "okta-token-storage_accessToken";
export const LOGGED_IN_TOKEN = "logged-in-token";
export const ZALES_MIRROR_APP_STREAM_ID = '2757255477';
